import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDwV8O7Y3bELsVuO-KRKdd0a8Ah20UiwRI",
    authDomain: "senseway-haseko-hlss-test.firebaseapp.com",
    projectId: "senseway-haseko-hlss-test",
    storageBucket: "senseway-haseko-hlss-test.appspot.com",
    messagingSenderId: "786827186886",
    appId: "1:786827186886:web:e007b3d3db98d2ca867dc7",
    measurementId: "G-NCCX01TMDG"
  },
  googleMapsApiKey: "AIzaSyCEBy1pmeVf-5undtfDlXDkRx5jsfOSNIg",
  googleMapsMapId: "a24a8264c33a74f8623be0ce",
  weatherNews: {
    functionsUrl: "https://getweathernews-nnq7cy33ca-an.a.run.app"
  }
};
